define('lib/leaflet-small-map/leaflet-small-map-helpers',[],function() {
  return {
    createDomElement: createDomElement,
    addEventListeners: addEventListeners,
  };

  function createDomElement(type, options) {
    var element = document.createElement(type);
    if (!options) options = {};

    if (options.id) {
      element.setAttribute('id', options.id);
    }
    if (options.placeholder) {
      element.setAttribute('placeholder', options.placeholder);
    }
    if (options.title) {
      element.setAttribute('title', options.title);
    }
    if (options.cssClass) {
      options.cssClass.split(' ').forEach(function(cssClass) {
        element.classList.add(cssClass);
      });
    }
    if (options.content) {
      element.innerHTML = options.content;
    }
    if (options.clickCallback) {
      element.addEventListener('click', options.clickCallback);
    }

    if (options.attributes) {
      var propNames = Object.keys(options.attributes);
      propNames.forEach(function(propName) {
        element.setAttribute(propName, options.attributes[propName]);
      });
    }
    return element;
  }

  function addEventListeners(config) {
    config.elements.forEach(function(element) {
      config.events.forEach(function(event) {
        element.addEventListener(event, config.callback);
      });
    });
  }
});

